import { AnimationControls, motion } from "framer-motion";
import { PropsWithClassName, cn } from "kz-ui-sdk";
import { useTranslation } from "react-i18next";
import ShimmerBadge from "./ShimmerBadge";
import { ANIMATION_STATE, registerGiftTextVariant } from "./utils";

interface RegisterGiftTextProps extends PropsWithClassName {
  zIndex: number;
  controls: AnimationControls;
}

const RegisterGiftText = ({ className, zIndex, controls }: RegisterGiftTextProps) => {
  const { t } = useTranslation();

  return (
    <motion.div
      className={cn("relative w-fit cursor-pointer", className)}
      variants={registerGiftTextVariant}
      initial={ANIMATION_STATE.IDLE}
      animate={controls}
      role="button"
      tabIndex={0}
      aria-label={t("Register a free gift")}
    >
      <div className="relative flex w-fit flex-col items-center" style={{ zIndex }}>
        <ShimmerBadge />
      </div>
    </motion.div>
  );
};

export default RegisterGiftText;
